// src/components/settings/shared/dialogs/KennelSizeDialog.tsx
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Edit as EditIcon, Add as AddIcon } from '@mui/icons-material';
import DialogBase from '../../../common/modal/DialogBase';
import {
  DailogLabel,
  DialogLabelText,
  StyledTextField,
} from '../../../forms/shared/FormElements';
import FieldHelperText from '../../../forms/shared/FieldHelperText';
import { ModalCancelButton, ModalSaveButton } from '../../../common/Buttons';
import { KennelSize } from '../../../../services/api';

interface KennelSizeDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: { name: string; sortOrder: number }) => void;
  editing: KennelSize | null;
}

const KennelSizeDialog: React.FC<KennelSizeDialogProps> = ({
  open,
  onClose,
  onSave,
  editing,
}) => {
  const [formData, setFormData] = useState({ name: '', sortOrder: 0 });

  useEffect(() => {
    if (open) {
      setFormData(
        editing
          ? { name: editing.name, sortOrder: editing.sortOrder }
          : { name: '', sortOrder: 0 }
      );
    }
  }, [open, editing]);

  const canSave = formData.name.trim().length > 0;
  const isSystem = !!editing?.isSystem;

  return (
    <DialogBase
      open={open}
      onClose={onClose}
      title={editing ? 'Edit Kennel Size' : 'Add Kennel Size'}
      headerIcon={editing ? <EditIcon /> : <AddIcon />}
      draggable
      footer={
        <>
          <ModalCancelButton
            onClick={onClose}
            sx={{
              minWidth: { xs: 'auto', sm: '160px' },
              '& .MuiButton-startIcon': { display: { xs: 'none', sm: 'flex' } },
            }}
          />
          <ModalSaveButton
            onClick={() => onSave(formData)}
            disabled={!canSave}
            text="Save"
            sx={{
              minWidth: { xs: 'auto', sm: '160px' },
              '& .MuiButton-startIcon': { display: { xs: 'none', sm: 'flex' } },
            }}
          />
        </>
      }
    >
      <Box display="flex" flexDirection="column" gap={0.5} mt={0.2}>
        <DailogLabel>
          <DialogLabelText>Size Name:</DialogLabelText>
        </DailogLabel>
        <StyledTextField
          value={formData.name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFormData({ ...formData, name: e.target.value })
          }
          required
          fullWidth
          disabled={isSystem}
        />
        {isSystem && (
          <FieldHelperText helperText="Standard system item - name cannot be changed." />
        )}
        <DailogLabel>
          <DialogLabelText>Sort Order:</DialogLabelText>
        </DailogLabel>
        <StyledTextField
          type="number"
          value={formData.sortOrder}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFormData({ ...formData, sortOrder: Number(e.target.value) })
          }
          fullWidth
        />
      </Box>
    </DialogBase>
  );
};

export default KennelSizeDialog;
